import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
import DataTable from "../../DataTable/DataTable"

class CustomerPresenterHistory extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    // console.log("cust_history", this.props)
    var tabClasses = clsx({
      'active': this.props.active_tab == 'history',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="history">
        <div className="clearfix"></div>
        <DataTable 
          endpoint = {this.props.history_endpoint}
          no_data_text = {I18n.t('none')}
          date_format = {this.props.date_format}
          time_format = {this.props.time_format}
          model_name={"Customer"}
         
        />
      </div>
    ) 
  }
};

export default CustomerPresenterHistory